import { getTemplatesState } from '@containers/templates/templates.selectors'
import { FetchTemplatesRequest } from '@containers/templates/templates.actions'
import {
  SetDefaultData,
  UpdateField,
  UpdateCompoundSettingsRequest,
  FetchCompoundSettingsRequest,
} from './compound-settings.actions'
import { getCompoundSettingsState } from './compound-settings.selectors'
import Validator from '@shared/validatorjs/src/validator'
import { ActivatedRoute } from '@angular/router'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Map, List } from 'immutable'
import { debounceTime, Subject, Subscription } from 'rxjs'
import { CompoundSettings } from './compound-settings.interface'

@Component({
  selector: 'app-compound-settings',
  templateUrl: './compound-settings.component.html',
  styleUrls: ['./compound-settings.component.css'],
})
export class CompoundSettingsComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public forms: []

  public isLoading: boolean
  public userId: number
  private state$: Subscription
  private templatesState$: Subscription
  public compoundSettings: CompoundSettings
  public templates: [] = []
  public onTemplatesAutocomplete$ = new Subject<string>()
  public templatesAutocomplete$: Subscription

  constructor(public store: Store<any>, private route: ActivatedRoute) {
    super()
  }

  ngOnInit() {
    this.userId = parseInt(this.route.snapshot.paramMap.get('id'), 10)
    this.store.dispatch<any>(new SetDefaultData('settings'))

    this.templatesAutocomplete$ = this.onTemplatesAutocomplete$
      .pipe(debounceTime(500))
      .subscribe((keyword) => {
        if (keyword) {
          this.store.dispatch<any>(
            new FetchTemplatesRequest({
              filters: keyword
                ? {
                    or: [{ field: 'name', value: keyword }],
                    and: [{ field: 'type', value: 'CP_TEMPLATE' }],
                  }
                : {},
              pageSize: 20,
            }),
          )
        }
      })

    this.state$ = this.store
      .pipe(select(getCompoundSettingsState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
        this.compoundSettings = state.get('data').toJS()
      })

    this.templatesState$ = this.store
      .pipe(select(getTemplatesState))
      .subscribe((state) => {
        this.templates = state.get('data').toJS()
      })

    this.store.dispatch<any>(new FetchCompoundSettingsRequest())
    this.store.dispatch<any>(
      new FetchTemplatesRequest({
        pageSize: 50,
        filters: {
          and: [{ field: 'type', value: 'CP_TEMPLATE' }],
        },
      }),
    )
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.templatesState$.unsubscribe()
    this.templatesAutocomplete$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(new UpdateField(name, e, `data`))

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(`compoundSettings.${name}`),
        '',
      ),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      SETTINGS_COMPOUNDS_TEMPLATE: 'required',
      SETTINGS_COMPOUNDS_MAX_TAX: 'required',
      SETTINGS_COMPOUNDS_MIN_TAX: 'required',
    }
    const validator = new Validator(data.toJS(), rules, {
      required: 'The field is required.',
    })

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const {
      SETTINGS_COMPOUNDS_MIN_TAX,
      SETTINGS_COMPOUNDS_MAX_TAX,
      ...payload
    } = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(
        new UpdateCompoundSettingsRequest(this.userId, {
          SETTINGS_COMPOUNDS_MIN_TAX: parseFloat(SETTINGS_COMPOUNDS_MIN_TAX),
          SETTINGS_COMPOUNDS_MAX_TAX: parseFloat(SETTINGS_COMPOUNDS_MAX_TAX),
          ...payload,
        }),
      )
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, ''),
      )
    }
  }
}
